import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ResponsiveView = ({ children, desktop = true }) => {
  const Container = desktop ? DesktopContainer : MobileContainer;

  return (
    <Container>
      {children}
    </Container>
  );
};

ResponsiveView.propTypes = {
  children: PropTypes.node,
  desktop: PropTypes.bool,
};

const DesktopContainer = styled.div`
  display: block;
  ${(p) => p.theme.max('md')`
    display: none;
  `}
`;

const MobileContainer = styled.div`
  display: none;
  ${(p) => p.theme.max('md')`
    display: block;
    width: 100%;
  `}
`;


export default ResponsiveView;
